import type { UseQueryResult } from '@tanstack/react-query'
import { useQuery } from '@tanstack/react-query'

import { QUERIES } from '@/enums/queries'
import { globalQueryClient } from '@/queries/queryClient'
import type { DemographicsOption } from '@/types/integrations/demographics'

import { getDemographicsOptions } from './services/loadDemographicsIntegration'

export const useLoadDemographicsIntegration = (
  options: Record<string, unknown> = {}
): UseQueryResult<DemographicsOption[] | undefined, Error> => {
  return useQuery({
    queryKey: [QUERIES.INTEGRATIONS.DEMOGRAPHICS.GET],
    queryFn: () => {
      return getDemographicsOptions()
    },
    keepPreviousData: true,
    cacheTime: 1000 * 60 * 10, // 10 minutes
    ...options,
  })
}

export const invalidateLoadDemographicsIntegration = async () => {
  await globalQueryClient.invalidateQueries({
    queryKey: [QUERIES.INTEGRATIONS.DEMOGRAPHICS.GET],
    exact: false,
  })
}
